import { Grid, Stack, Typography } from "@mui/material";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import ClearIcon from "@mui/icons-material/Clear";
import { black, blue } from "@/theme/colors";
import { useFormContext, useWatch } from "react-hook-form";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { useEffect, useRef, useState } from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { ConfirmDeleteModal } from "@/components/commons/ConfirmDeleteModal";

export const TalentFormHeldQualificationsFields = () => {
  const { control, setValue, trigger, formState, clearErrors } = useFormContext<TTalentForm>();
  const [deleteIndex, setDeleteIndex] = useState<number | null>(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const heldQualifications = useWatch({ control, name: "heldQualifications" }) || [""];

  const handleAddField = () => {
    if (heldQualifications.length < 10) {
      isAddingRef.current = true;
      const updated = [...heldQualifications, ""];
      setValue("heldQualifications", updated);
    }
  };

  const handleRemoveField = (index: number) => {
    if (heldQualifications.length > 1) {
      const value = heldQualifications[index];
      if (!value || value.trim() === "") {
        clearErrors("heldQualifications");
        const updated = heldQualifications.filter((_, i) => i !== index);
        setValue("heldQualifications", updated);
      } else {
        setDeleteIndex(index);
        setIsDeleteModalOpen(true);
      }
    }
  };

  const confirmDelete = () => {
    if (deleteIndex !== null && heldQualifications.length > 1) {
      clearErrors("heldQualifications");
      const updated = heldQualifications.filter((_, i) => i !== deleteIndex);
      setValue("heldQualifications", updated);
    }
    setIsDeleteModalOpen(false);
    setDeleteIndex(null);
  };

  useEffect(() => {
    if (!heldQualifications || heldQualifications.length === 0) {
      setValue("heldQualifications", [""]);
    }
  }, [heldQualifications, setValue]);

  const isAddingRef = useRef(false);
  useEffect(() => {
    if (isAddingRef.current) {
      isAddingRef.current = false;
      return;
    }
    if (formState.isSubmitted) {
      trigger("heldQualifications");
    }
  }, [heldQualifications, trigger, formState.isSubmitted]);

  return (
    <>
      <Stack mt={2}>
        <Typography variant="cap12" sx={{ mb: 1 }}>
          資格
        </Typography>

        {heldQualifications.map((_, index) => {
          const isLast = index === heldQualifications.length - 1;
          return (
            <Stack key={index} sx={{ mb: isLast ? 0 : 2 }}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormField control={control} name={`heldQualifications.${index}`}>
                    <Input placeholder="入力してください" />
                  </FormField>
                </Grid>
              </Grid>

              <Stack direction="row" alignItems="center" spacing={3} mt={1} sx={{ position: "relative", zIndex: 1 }}>
                {isLast && heldQualifications.length < 10 && (
                  <Stack direction="row" alignItems="center" spacing={0.5} sx={{ cursor: "pointer" }} onClick={handleAddField}>
                    <AddCircleOutlineIcon sx={{ color: blue[80], fontSize: 18 }} />
                    <Typography variant="cap12">資格を追加</Typography>
                  </Stack>
                )}
                {heldQualifications.length > 1 && (
                  <Stack direction="row" alignItems="center" spacing={0.5} sx={{ cursor: "pointer" }} onClick={() => handleRemoveField(index)}>
                    <ClearIcon sx={{ color: black[80], fontSize: 18, display: "flex" }} />
                    <Typography variant="cap12">削除</Typography>
                  </Stack>
                )}
              </Stack>
            </Stack>
          );
        })}
      </Stack>

      <ConfirmDeleteModal
        open={isDeleteModalOpen}
        onClose={() => {
          setIsDeleteModalOpen(false);
          setDeleteIndex(null);
        }}
        onOk={confirmDelete}
        message="「資格」を削除してもよろしいですか？"
      />
    </>
  );
};
